import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { cn } from "@babackapp/ui/lib/utils";
import FormInputContainer from "./form-input-container";

type FormOptionsSelectorOption = {
  label: string;
  description?: string;
  key: string | number;
};

export type FormOptionsSelectorProps = {
  label: string;
  description?: string;
  value: string | number;
  options: FormOptionsSelectorOption[];
  onChange: (value: string | number) => void;
  disabled?: boolean | string;
};

export default function FormOptionsSelector({
  value,
  onChange,
  options,
  label,
  description,
  disabled,
}: FormOptionsSelectorProps) {
  const _onChange = (v: string) => {
    if (typeof value === "string") return onChange(v);
    return onChange(+v);
  };

  return (
    <FormInputContainer
      label={label}
      description={description}
      disabled={disabled}
    >
      <Select
        value={`${value}`}
        onValueChange={_onChange}
        disabled={!!disabled}
      >
        <SelectTrigger
          className={cn(
            "max-h-auto h-auto border-2",
            disabled && "cursor-not-allowed",
          )}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.key} value={`${option.key}`}>
              <div className="flex flex-col gap-1 cursor-pointer">
                <span className="text-left">{option.label}</span>
                {option.description && (
                  <span className="text-left text-xs text-muted-foreground font-medium">
                    {option.description}
                  </span>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormInputContainer>
  );
}
